<template>
  <div class="flex flex-wrap gap-3">
    <a
      v-if="links.appStore"
      :href="links.appStore"
      target="_blank"
      rel="noopener"
      class="store-btn"
    >
      <PhAppleLogo weight="fill" class="size-6" />
      <span class="leading-tight"><span class="block text-[10px] font-normal uppercase tracking-wide opacity-80">Download on the</span>App Store</span>
    </a>
    <a
      v-if="links.googlePlay"
      :href="links.googlePlay"
      target="_blank"
      rel="noopener"
      class="store-btn"
    >
      <PhGooglePlayLogo weight="fill" class="size-6" />
      <span class="leading-tight"><span class="block text-[10px] font-normal uppercase tracking-wide opacity-80">Get it on</span>Google Play</span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { PhAppleLogo, PhGooglePlayLogo } from '@phosphor-icons/vue'

defineProps<{ links: { appStore?: string, googlePlay?: string } }>()
</script>

<style scoped>
.store-btn {
  @apply inline-flex items-center gap-3 rounded-xl bg-primary-dark px-4 py-2.5 text-sm font-semibold text-white shadow-soft transition-all duration-300 hover:-translate-y-0.5 hover:shadow-soft-lg dark:bg-white dark:text-primary-dark;
}
</style>
